export default function (context) {
    context.items = [];
    context.selections = [];
}